import { gql } from "@apollo/client"

export const GET_CUSTOMER_LOYALTY_QUERY = gql`
    query getCustomerLoyaltyQuery {
        getCustomerLoyalty {
            userId
            name
            type
            cardNumber
            expiry
            dateAdded
            transactionCode
            transactionDate
            pickupBranch
            seqNo
            updated
            point
            isExpired
            _id
        }
    }
`

export const ADD_LOYALTY = gql` 
    mutation addLoyaltyMutation($cardNumber: String,$name: String) {
        addLoyalty(cardNumber:$cardNumber, name:$name) 
    }
`